import React, { useEffect, useState } from "react";
import { UserApiCalls } from "../../apis/UserApiCalls";
import YuJaButton from "../../components/standardization/YuJaButton";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import { useTranslation } from "react-i18next";
import {
    DEFAULT_TOAST_MESSAGE_DURATION,
    DEFAULT_LANGUAGE,
    USER_SETTINGS,
    MENU_LIST,
} from "../../utils/constants";
import classes from "./Settings.module.css";
import UserSettingTab from "./UserSettingTab";
import {notifySuccess} from "../../utils/helpers";

export default function ViewerSettings({ setPageIdentifier }) {
    const { t } = useTranslation();
    const [, getSession] = useLocalStorageNew("session", {});
    const [userSettings,  setUserSettings] = useState(() => {
        const {settings={}} = getSession();
        if (!settings.hasOwnProperty(USER_SETTINGS.TOAST_MESSAGE_DURATION)) {
            settings[USER_SETTINGS.TOAST_MESSAGE_DURATION] = DEFAULT_TOAST_MESSAGE_DURATION.toString();
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.LANGUAGE)) {
            settings[USER_SETTINGS.LANGUAGE] = DEFAULT_LANGUAGE;
        }
        return settings;
    });
    const [saveLoading, setSaveLoading] = useState(false);

    useEffect(() => {
        if(document.getElementById("userLastElem") != null) {
            document.getElementById("userLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("settingsSaveBtn")) {
                  e.preventDefault();
                  document.getElementById('settingsSaveBtn').focus();
                }
            });
        }

        setPageIdentifier(MENU_LIST.SETTINGS_STUDENT.name);
        
        const handleWindowResize = () => {
          setPageIdentifier(MENU_LIST.SETTINGS_STUDENT.name);
        };
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const {saveSettings} = UserApiCalls();

    const handleSaveUserSettings = () => {
        setSaveLoading(true);
        saveSettings(userSettings).then(() => {
            notifySuccess(t("settings.saveSuccess"));
        }).finally(() => {
            setSaveLoading(false);
        });
    }

    return (
        <div className={classes.container}>
            <div style={{display: "flex", alignItems: "center"}}>
                <span style={{flex: 1}}/>
                <YuJaButton
                    id="settingsSaveBtn"
                    index={0}
                    onClick={handleSaveUserSettings}
                    disabled={saveLoading}
                    style={{
                        height: 36,
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}
                >
                    <span className={saveLoading ? classes.savingText : ""}>
                        {t("institution.saveChangesText")}
                    </span>
                </YuJaButton>
            </div>

            <div className={`${classes.tabPane} ${classes.active}`}>
                <UserSettingTab userSettings={userSettings} setUserSettings={setUserSettings} isViewer={true}/>
            </div>
        </div>
    )
};